import React from 'react';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { deleteLedmodule, setTemporaryLedmodule } from '../../actions';

class Handler extends React.Component {


    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {

            if (prevProps.isTemporary
                && (prevProps.location.pathname.endsWith("info"))
                && (!this.props.location.pathname.endsWith("info"))) {

                this.props.deleteLedmodule(prevProps.ledmodule.id);
                this.props.setTemporaryLedmodule(false);
            }
        }
    }

    render() {
        return (
            <div>
                <Prompt
                    when={this.props.isTemporary && (this.props.location.pathname.endsWith("info"))}
                    message={location =>
                        this.props.isTemporary && !location.pathname.endsWith("info")
                            ? "You have not saved, your ledmodule will be deleted. Are you sure you want to leave?"
                            : true}
                />
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ledmodule: state.ledmodule.info,
        isTemporary: state.ledmodule.isTemporary
    };
};

const mapDispatchToProps = {
    deleteLedmodule,
    setTemporaryLedmodule
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Handler));